import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  standalone: false,
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() pageNumber: number = 1;
  @Input() totalPages: number = 1;
  @Input() pageSize: number = 10;
  @Input() totalItems: number = 0;

  @Output('onPageChange') onPageChange: any = new EventEmitter();

  tempPagesArray: any[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.regeneratePagesArray();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.regeneratePagesArray();
  }

  get startItem(): number {
    if (this.totalItems === 0) {
      return 0;
    }
    return (this.pageNumber - 1) * this.pageSize + 1;
  }

  get endItem(): number {
    if (this.totalItems === 0) {
      return 0;
    }
    return Math.min(this.pageNumber * this.pageSize, this.totalItems);
  }

  regeneratePagesArray() {
    // 1 2 ... 5 6 7 ... 9 10

    if (this.totalPages <= 0) {
      this.tempPagesArray = [];
      return;
    }

    if (this.totalPages > 10) {
      const allPages = Array(this.totalPages).fill(0).map((x, i) => i + 1);

      if (this.pageNumber < 4) {
        this.tempPagesArray = [...allPages.slice(0, 4), '...', this.totalPages];
      } else if (this.pageNumber > this.totalPages - 3) {
        this.tempPagesArray = [1, '...', ...allPages.slice(this.totalPages - 4)];
      } else {
        this.tempPagesArray = [1, '...', ...allPages.slice(this.pageNumber - 2, this.pageNumber + 1), '...', this.totalPages];
      }
    } else {
      this.tempPagesArray = Array(this.totalPages).fill(0).map((x, i) => i + 1);
    }
  }

  gotoPage(pageNumber: number) {
    if (pageNumber < 1 || pageNumber > this.totalPages) {
      return;
    }
    if (pageNumber !== this.pageNumber) {
      this.onPageChange.emit(pageNumber);
    }
  }
}
